import { render, staticRenderFns } from "./RefundV2.vue?vue&type=template&id=4af9620c"
import script from "./RefundV2.vue?vue&type=script&lang=js"
export * from "./RefundV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports